export { default as Home } from './Home';
export { default as Services } from './Services';
export { default as Detalization } from './Detalization';
export { default as DetalizationNew } from './DetalizationNew';
export { default as Messages } from './Messages';
export { default as Settings } from './Settings';
export { default as PersonalData } from './PersonalData';
export { default as PersonalDataExternal } from './PersonalDataExternal';
export { default as Internet } from './Internet';
export { default as TV } from './TV';
export { default as Insurance } from './Insurance';
export { default as Family } from './Family';
export { default as FamilyChild } from './FamilyChild';
